import Parse from 'parse/dist/parse.min.js';

// Initialize Parse
Parse.initialize(
  'YTSPfzyS82yazNYS1SCTIBBuMoP7SZfJI5WYv0HY', // Application ID
  'tWKY9BVp9r0xQqEq2pu3cuLWsz3Qrqq0FUOI2NVf', // JavaScript key
  'YQAhfNXDcfuMpGMKDzJvIjZQvNjmKJJQxKGbqYJM'  // Master key (only use on server side)
);

// Nota: Parse.Cloud.useMasterKey() solo funciona en el servidor
// En el cliente, debemos usar Cloud Functions para operaciones que requieran Master Key

Parse.serverURL = 'https://parseapi.back4app.com/';

export default Parse;
